import React, { useRef, useState, useLayoutEffect } from "react";
import "./NurtureReplyCard.css";
import TagOverflowHandlerV2 from "../../../../uiUtils/TagOverflowHandlerV2";

export default function NurtureReplyCard({
  sender = "",
  email = "",
  date="",
  viewMoreText = "View more",
  viewLessText = "View less",
}) {
  const [expanded, setExpanded] = useState(false);
  const [collapsedHeight, setCollapsedHeight] = useState(80); // default uniform height

  const measureRef = useRef(null);

  useLayoutEffect(() => {
    if (!measureRef.current) return;

    const fullH = measureRef.current.scrollHeight;
    // collapse height = 10% of full content height (but same for all cards)
    const target = Math.round(fullH * 0.1);
    setCollapsedHeight(target > 60 ? target : 60); // at least 60px
  }, []);

  return (
    <div className="nrc-card">
      {date && <div className="nrc-subject"><TagOverflowHandlerV2 data={date}/> Reply from- {sender} </div>}

      {/* hidden measurer for full height */}
      <div ref={measureRef} className="nrc-email-measure">
        {email}
      </div>

      <div
        className={`nrc-email ${expanded ? "expanded" : "collapsed"}`}
        style={{
          maxHeight: expanded ? "none" : collapsedHeight,
        }}
      >
        {email}
      </div>

      <div className="nrc-toggle-wrap">
        <button
          type="button"
          className="nrc-toggle"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? viewLessText : viewMoreText}
        </button>
      </div>
    </div>
  );
}
